<template>
  <div :style="indicatorStyles">
    <div class="vcl-thinking__indicator"></div>
    <div class="vcl-thinking__indicator"></div>
    <div class="vcl-thinking__indicator"></div>
  </div>
</template>

<script>
export default {
  name: 'VpThinking',
  props: {
    styles: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    indicatorStyles() {
      return {
        '--thinking-indicator-color': this.styles.thinkingIndicatorColor || '#fff'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .vcl-thinking__indicator {
    border-radius: 50%;
    background-color: var(--thinking-indicator-color);
    display: inline-block;
    margin: 0 4px;
    animation-name: pulse;
    animation-duration: 1.2s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
    opacity: .5;
    height: .8em;
    width: .8em;
  }
  .vcl-thinking__indicator:nth-child(1n) { 
    animation-delay: 0s;
  }
  .vcl-thinking__indicator:nth-child(2n) {
    animation-delay: 400ms;
  }
  .vcl-thinking__indicator:nth-child(3n) {
    animation-delay: 800ms;
  }
  .vcl-button.red.no-fill .vcl-thinking__indicator {
     --thinking-indicator-color: #CE3C31;
  }
  .vcl-button.blue.no-fill .vcl-thinking__indicator {
     --thinking-indicator-color: #016699;
  }
  .vcl-button.orange.no-fill .vcl-thinking__indicator {
     --thinking-indicator-color: #F58220;
  }
  @keyframes pulse {
    0%, 33.33333% {
      opacity: 1;
    }
    33.33334% {
      opacity: 0.5;
    }
  }
</style>